import DateRangePicker from '../../../../shared/date-range-picker';

const SearchIcon = () => (
    <svg width='16' height='16' viewBox='0 0 24 24' fill='none'>
        <path
            d='M21 21l-4.35-4.35M10.8 18a7.2 7.2 0 1 1 0-14.4 7.2 7.2 0 0 1 0 14.4Z'
            stroke='currentColor'
            strokeWidth='1.8'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

const UsersNeedHelpFilters = ({
    totalElements,
    search,
    onSearchChange,
    dateFrom,
    dateTo,
    onDateChange,
}: {
    totalElements: number;
    search: string;
    onSearchChange: (value: string) => void;
    dateFrom?: string;
    dateTo?: string;
    onDateChange: (next: { dateFrom?: string; dateTo?: string }) => void;
}) => {
    return (
        <div className='flex flex-col gap-3 md:flex-row md:items-center md:justify-between my-4'>
            <div className='flex flex-wrap items-center gap-3'>
                <h4 className='text-sm font-semibold px-2'>
                    Showing {totalElements} queries
                </h4>
            </div>

            <div className='flex flex-col md:flex-row gap-3 w-full md:w-auto'>
                <div className='relative w-full md:w-[280px]'>
                    <span className='absolute left-4 top-1/2 -translate-y-1/2 text-gray-400'>
                        <SearchIcon />
                    </span>
                    <input
                        value={search}
                        onChange={(e) => onSearchChange(e.target.value)}
                        placeholder='Search'
                        className='w-full rounded-2xl border bg-white dark:bg-black pl-11 pr-4 py-3 text-sm text-black dark:text-white border-gray-200 dark:border-borderColor-darkMode focus:outline-none focus:ring-0 focus:ring-offset-0 focus:border-gray-300 dark:focus:border-gray-600'
                    />
                </div>

                <DateRangePicker
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    placeholder='Select date range'
                    onChange={onDateChange}
                />
            </div>
        </div>
    );
};

export default UsersNeedHelpFilters;
